<template>
  <div class="templateClass">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span class="headerTitle">任务器配置</span>
        <div class="tobbox">
          <div class="tobboxItem">
            <label class="sum">开始时间</label>
            <el-date-picker
              style="width:250px"
              v-model="startTime"
              type="date"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy/MM/dd HH:mm:ss"
              placeholder="选择日期"
            ></el-date-picker>
          </div>
          <div class="tobboxItem">
            <label class="sum">结束时间</label>
            <el-date-picker
              style="width:250px"
              v-model="endTime"
              type="date"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy/MM/dd HH:mm:ss"
              placeholder="选择日期"
            ></el-date-picker>
          </div>
        </div>
      </div>
      <div slot="header" class="clearfix">
        <span class="headerTitle">节能空间分析参数配置</span>
      </div>
      <div class="cardContent">
        <div style="display: flex;margin-bottom: 22px;">
          <label class="sum">报告名称</label>
          <el-input
            clearable
            placeholder="请输入报告名称"
            v-model="baseName"
          ></el-input>
        </div>
        <el-form label-position="right" label-width="120px" :model="formObject">
          <el-form-item label="公司项目名称">
            <el-input
              clearable
              placeholder="请输入公司项目名称"
              v-model="formObject.projectName"
            ></el-input>
          </el-form-item>

          <el-form-item label="电压等级">
            <el-input v-model="formObject.voltageGrade"></el-input>
          </el-form-item>

          <el-form-item label="进线路数">
            <el-input
              clearable
              placeholder="请输入进线路数"
              v-model="formObject.intoTheLineNumber"
            ></el-input>
          </el-form-item>

          <el-form-item label="运行方式1">
            <el-input
              clearable
              placeholder="请输入运行方式1"
              v-model="formObject.measurementMethods"
            ></el-input>
          </el-form-item>

          <el-form-item label="变压器数量">
            <el-input-number
              class="input180"
              v-model="formObject.transformerNumber"
              :min="1"
              label="请输入变压器数量"
            ></el-input-number>
          </el-form-item>

          <el-form-item label="运行方式2">
            <el-input
              clearable
              placeholder="请输入运行方式2"
              v-model="formObject.runWay"
            ></el-input>
          </el-form-item>

          <el-form-item label="计量点Id">
            <label class="point-name">{{ formObject.measureName }}</label>
            <label class="btn-point" @click="selectPoint()">选择测量点</label>
          </el-form-item>

          <el-form-item label="负荷率标准">
            <el-input-number
              class="input180"
              v-model="formObject.loadRateStandard"
              :min="1"
              label="请输入负荷率标准，百分比数"
            ></el-input-number>
          </el-form-item>

          <el-form-item label="变压器列表">
            <el-button
              style="float:left;margin-bottom: 10px;"
              type="primary"
              @click="openModel1"
              >新增变压器</el-button
            >
            <el-table
              :data="formObject.childrenList"
              border
              style="width: 100%;margin-top:15px;"
            >
              <!-- style="width: 100%;height:200px;margin-top:15px;overflow: auto;" -->
              <el-table-column
                type="index"
                :index="1"
                label="#"
                width="80"
              ></el-table-column>
              <el-table-column
                prop="name"
                label="变压器名称"
                min-width="180"
              ></el-table-column>
              <el-table-column
                prop="switchName"
                label="进线开关编号"
                min-width="180"
              ></el-table-column>

              <el-table-column
                prop="transformerNumber"
                label="变压器编号"
                min-width="180"
              ></el-table-column>

              <el-table-column
                prop="capacity"
                label="变压器容量"
                min-width="180"
              ></el-table-column>

              <el-table-column
                prop="measureId"
                label="变压器id"
                min-width="100"
              ></el-table-column>

              <el-table-column fixed="right" label="操作" width="90">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    size="small"
                    @click="editRow(scope.$index, formObject.childrenList)"
                    >编辑</el-button
                  >
                  <el-button
                    @click="removeRow(scope.$index, formObject.childrenList)"
                    type="text"
                    size="small"
                    >移除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </el-form>

        <div class="pageCauda">
          <el-button type="success" @click="savePageAllData"
            >立即保存</el-button
          >

          <el-button @click="resetForm">重置</el-button>
        </div>
      </div>
    </el-card>
    <!-- 选择测量点 -->
    <el-dialog
      title="请选择树节点(单选)"
      :visible.sync="selectNodeDialog"
      custom-class="dialog"
      :close-on-click-modal="false"
    >
      <div class="dialog-info">
        <div class="view-tree">
          <div
            :class="[
              'view-tree-item',
              index === viewTreeIndex ? 'view-tree-select' : '',
            ]"
            v-for="(item, index) in viewTree"
            :key="index"
            @click="viewTreeClick(item, index)"
          >
            {{ item.displayName }}
          </div>
        </div>
        <div class="dialog-box" style="width:100%;height:300px;">
          <nk-left-tree
            ref="tree"
            :defaultCurrent="false"
            :data="leftTreeData"
            v-if="leftTreeData.length > 0"
            @click="nodeClick"
          ></nk-left-tree>
        </div>
      </div>
    </el-dialog>
    <!-- 模态窗1 -->
    <el-dialog
      :title="modeltitle"
      :visible.sync="isShowModal1"
      center
      width="35%"
      :close-on-click-modal="false"
    >
      <el-form
        label-position="right"
        ref="childrenObjectFrom"
        :model="childrenObject"
        label-width="120px"
      >
        <el-form-item label="变压器名称">
          <el-input
            clearable
            placeholder="请输入变压器名称"
            v-model="childrenObject.name"
          ></el-input>
        </el-form-item>
        <el-form-item label="进线开关编号">
          <el-input
            clearable
            placeholder="请输入进线开关编号"
            v-model="childrenObject.switchName"
          ></el-input>
        </el-form-item>

        <el-form-item label="变压器编号">
          <el-input
            type="textarea"
            :rows="2"
            clearable
            placeholder="请输入变压器编号"
            v-model="childrenObject.transformerNumber"
          ></el-input>
        </el-form-item>

        <el-form-item label="变压器容量">
          <el-input-number
            class="input180"
            v-model="childrenObject.capacity"
            :min="1"
            label="请输入变压器容量"
          ></el-input-number>
        </el-form-item>

        <el-form-item label="变压器id">
          <!-- <el-input
            clearable
            placeholder="请输入变压器id"
            v-model="childrenObject.measureId"
          ></el-input> -->
          <label class="point-name">{{ childrenObject.measureName }}</label>
          <label class="btn-point" @click="selectPoint('diglog')"
            >选择测量点</label
          >
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isShowModal1 = false">取 消</el-button>
        <el-button type="primary" @click="addNewTableRow">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as utils from "@/utils/index.js";
import NkLeftTree from "./NkLeftTree.vue";
export default {
  components: { NkLeftTree },
  props: {
    reportData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isShowModal1: false,
      modeltitle: "新增变压器",
      formObject: {
        projectName: "",
        voltageGrade: "",
        intoTheLineNumber: "",
        measurementMethods: "",
        transformerNumber: "",
        runWay: "",
        measureId: "",
        measureName: "",
        loadRateStandard: "",
        childrenList: [],
      },
      childrenObject: {
        name: "贝恩一厂总进线柜",
        switchName: "贝恩一厂总进线柜",
        transformerNumber: "1#变压器，2#变压器，3#变压器",
        capacity: 5700,
        measureId: 6183926769436811776,
        measureName: "",
      },
      listIndex: 0,
      isUpdate: false,
      baseName: "",
      startTime: "",
      endTime: "",
      param: null,
      selectNodeDialog: false,
      viewTreeIndex: 0,
      viewTree: [],
      leftTreeData: [],
      isViewTreeData: true, //是否可以进行请求下次的视图树数据
    };
  },
  watch: {
    reportData: {
      handler(newVal, oldVal) {
        /* 加载视图树 */
        const {
          projectName = "",
          voltageGrade = "",
          intoTheLineNumber = "",
          measurementMethods = "",
          transformerNumber = "",
          runWay = "",
          measureId = "",
          measureName = "",
          loadRateStandard = "",
          childrenList = [],
        } = JSON.parse(newVal.params);
        this.formObject = {
          projectName,
          intoTheLineNumber,
          voltageGrade,
          measurementMethods,
          transformerNumber,
          runWay,
          measureId,
          measureName,
          loadRateStandard,
          childrenList,
        };
        this.baseName = newVal.baseName;
        this.startTime = newVal.startTime;
        this.endTime = newVal.endTime;
      },
      deep: true,
    },
  },
  mounted() {},
  created() {},
  methods: {
    //   立即保存点击事件
    async savePageAllData() {
      let vm = this;
      let res = await vm.$api.nhtj.modifyReportAutomaticGeneratingConfig(
        vm.$store.state.user.currentCompanyId,
        vm.reportData.model,
        vm.reportData.id,
        vm.baseName,
        JSON.stringify(vm.formObject),
        vm.reportData.loopRegulation,
        vm.startTime,
        vm.endTime,
        vm.reportData.groupId
      );
      if (res.success) {
        vm.$message.success("保存成功");
        vm.$emit("savePageAllData", true);
      }
    },
    //打开新增修改变压器的模态窗
    openModel1() {
      this.modeltitle = "新增变压器";
      this.childrenObject = {
        name: "",
        switchName: "",
        transformerNumber: "",
        capacity: 1,
        measureId: "",
        measureName: "",
      };
      this.isUpdate = false;
      this.isShowModal1 = true;
    },
    //修改一行变压器
    editRow(index, list) {
      this.modeltitle = "修改变压器";
      this.listIndex = index;
      this.isUpdate = true;
      this.childrenObject = list[index];
      this.isShowModal1 = true;
    },

    // 移除一变压器
    removeRow(index, tatleData) {
      tatleData.splice(index, 1);
    },
    addNewTableRow() {
      if (this.isUpdate) {
        this.formObject.childrenList[this.listIndex] = this.childrenObject;
      } else {
        this.formObject.childrenList.push(this.childrenObject);
      }

      this.isShowModal1 = false;
    },
    resetForm() {
      this.formObject = {
        projectName: "",
        voltageGrade: 1,
        intoTheLineNumber: "",
        measurementMethods: "",
        transformerNumber: 1,
        runWay: "",
        measureId: "",
        measureName: "",
        loadRateStandard: 1,
        childrenList: [],
      };
      if (this.$refs.childrenObjectFrom !== undefined) {
        this.$refs.childrenObjectFrom.resetFields();
      }
    },
    //树加载
    async bindGetTreeTabCode() {
      let vm = this;
      let res = await vm.$api.view.getCompanyViewTreesInfo(
        this.$store.state.user.info.companyId
      );
      if (res.success) {
        vm.viewTree = res.data;
        vm.viewTreeClick(res.data[0], 0);
      }
    },
    /* 选择计量点 */
    selectPoint(param) {
      //选择计量点触发的方法;item:数据源，index:第几个柜,pointIndex:第几个开关
      this.selectNodeDialog = true;
      this.param = param;
      this.bindGetTreeTabCode();
    },
    /* 选择视图节点 */
    async viewTreeClick(item, index) {
      let vm = this;
      if (!vm.isViewTreeData) {
        return;
      }
      vm.viewTreeIndex = index;
      vm.isViewTreeData = false; //避免不断点击，造成疯狂请求
      let result = await vm.$api.view.getViewTreeNodes(item.id);
      vm.isViewTreeData = true;
      if (!result.success) {
        vm.$message.error(result.msg);
        return;
      }
      vm.leftTreeData = utils.creatTreeData(result.data, 0);
    },
    /* 视图树节点点击事件 */
    nodeClick(data) {
      //节点点击

      let vm = this;
      console.log(
        "🚀 ~ file: energySavingSpace.vue ~ line 419 ~ nodeClick ~ data",
        vm.formObject
      );
      console.log(vm.param == "diglog");
      if (vm.param == "diglog") {
        vm.childrenObject.measureId = data.id;
        vm.childrenObject.measureName = data.label;
      } else {
        vm.formObject.measureName = data.label;
        vm.formObject.measureId = data.id;
      }
      vm.selectNodeDialog = false;
    },
    selectNodeEnter() {
      this.selectNodeDialog = false;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-form-item__content {
  text-align: left;
}
.templateClass {
  width: 100%;
  height: 100%;
  overflow: auto;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  .inputAuto {
    width: 100%;
  }
  .input180 {
    width: 180px;
  }
  .headerTitle {
    text-align: center;
    font-size: 22px;
  }
}
.sum {
  text-align: right;
  vertical-align: middle;
  float: left;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
  padding: 0 12px 0 0;
  box-sizing: border-box;
  width: 120px;
}
.dialog-info {
  display: flex;
  width: 100%;
  height: 300px;
  border: 1px solid #d5dadd;
  .view-tree {
    width: 200px;
    height: 300px;
    border-right: 1px solid #d5dadd;
    overflow-y: auto;
    .view-tree-item {
      line-height: 28px;
      padding: 0 5px;
      box-sizing: border-box;
      border-bottom: 1px dashed #d5dadd;
      cursor: pointer;
      font-size: 14px;
    }
    .view-tree-select {
      background: #d5dadd;
    }
  }
  .dialog-box {
    flex: 1;
    overflow-y: auto;
    padding: 0 5px;
    box-sizing: border-box;
    .tree-warp {
      height: 100%;
    }
  }
}
.btn-point {
  color: #409eff;
  cursor: pointer;
  margin-left: 6px;
}
.bm-item {
  color: #000;
}
.view-tree-select {
  background: #d5dadd;
}
.tobbox {
  padding: 10px;
  box-sizing: border-box;
  .tobboxItem {
    display: flex;
    margin-bottom: 22px;
  }
}
</style>
